const INITIAL_STATE = {};
const NAMESPACE = 'explorer/status';

const SET_REDIRECT_TO = `${NAMESPACE}/SET_REDIRECT_TO`;
const SET_NO_DIRECT_SERVICE_STATUS = `${NAMESPACE}/SET_NO_DIRECT_SERVICE_STATUS`;
const SET_NO_RESULTS_STATUS = `${NAMESPACE}/SET_NO_RESULTS_STATUS`;
const SET_INVALID_SEARCH = `${NAMESPACE}/SET_INVALID_SEARCH`;
const SET_HAS_RESULTS_STATUS = `${NAMESPACE}/SET_HAS_RESULTS_STATUS`;
const SET_SEARCHING = `${NAMESPACE}/SET_SEARCHING`;
const REMOVE_SEARCHING = `${NAMESPACE}/REMOVE_SEARCHING`;
const SET_SELECTED_CITY_STATUS = `${NAMESPACE}/SET_SELECTED_CITY_STATUS`;
const REMOVE_SELECTED_CITY_STATUS = `${NAMESPACE}/REMOVE_SELECTED_CITY_STATUS`;
const REMOVE_ALL_STATUSES = `${NAMESPACE}/REMOVE_ALL_STATUSES`;

export function removeAllStatuses() {
    return { type: REMOVE_ALL_STATUSES };
}

export function removeSearching() {
    return { type: REMOVE_SEARCHING };
}

export function removeSelectedCity(city) {
    return { type: SET_SELECTED_CITY_STATUS, city };
}

export function setHasResults(size) {
    return { type: SET_HAS_RESULTS_STATUS, size };
}

export function setInvalidSearch() {
    return { type: SET_INVALID_SEARCH };
}

export function setNoDirectStatus(payload) {
    return { type: SET_NO_DIRECT_SERVICE_STATUS, payload };
}

export function setNoResults() {
    return { type: SET_NO_RESULTS_STATUS };
}

export function setRedirectTo(url) {
    return { type: SET_REDIRECT_TO, url };
}

export function setSearching() {
    return { type: SET_SEARCHING };
}

export function setSelectedCity(city) {
    return { type: SET_SELECTED_CITY_STATUS, city };
}

function _setRedirectTo(state, url) {
    if (url) {
        return {
            ...state,
            redirectTo: { url },
            searching: false,
        };
    }
    return state;
}

function _setNoDirectStatus(state, payload = { nearbyCities: [] }) {
    if (payload) {
        return {
            ...state,
            searching: false,
            noDirectService: payload,
        };
    }
    return state;
}

function _setNoResults(state) {
    return {
        ...state,
        noResults: true,
        searching: false,
    };
}

function _setHasResults(state, size) {
    return {
        ...state,
        hasResults: { size },
        searching: false,
    };
}

function _setSearching(state) {
    return { searching: true };
}

function _removeSearching(state) {
    return { ...state, searching: false };
}

function _setSelectedCity(state, city) {
    if (city) {
        return { ...state, selectedCity: city };
    }
    return state;
}

function _removeSelectedCity(state) {
    const {
        selectedCity: _selectedCityToRemove,
        ...newState
    } = state;
    return newState;
}

function _setInvalidSearch(state) {
    return { ...state, invalidSearch: true };
}

function _removeAllStatuses() {
    return INITIAL_STATE;
}

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_REDIRECT_TO:
            return _setRedirectTo(state, action.url);
        case SET_NO_DIRECT_SERVICE_STATUS:
            return _setNoDirectStatus(state, action.payload);
        case SET_NO_RESULTS_STATUS:
            return _setNoResults(state);
        case SET_INVALID_SEARCH:
            return _setInvalidSearch(state);
        case SET_HAS_RESULTS_STATUS:
            return _setHasResults(state, action.size);
        case SET_SEARCHING:
            return _setSearching(state);
        case REMOVE_SEARCHING:
            return _removeSearching(state);
        case SET_SELECTED_CITY_STATUS:
            return _setSelectedCity(state, action.city);
        case REMOVE_SELECTED_CITY_STATUS:
            return _removeSelectedCity(state);
        case REMOVE_ALL_STATUSES:
            return _removeAllStatuses();
        default:
            return state;
    }
}
